import {
    Pencil1Icon,
    PlusCircledIcon,
} from '@radix-ui/react-icons';
import '../App.css';
import { MemberDataTable } from '../components/datatables/memberDatatable';
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../components/ui/accordion";
import { Button } from '../components/ui/button';
import {
    Dialog,
    DialogTrigger,
} from "../components/ui/dialog";

import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { ClubCompetitionsDatatable } from '../components/datatables/clubCompetitionsDatatable';
import InviteMemberDialog from '../components/dialogs/InviteMemberDialog';
import ExternalLinkWrapper from '../components/externalLinkWrapper';
import { Skeleton } from '../components/ui/skeleton';
import { toast } from '../components/ui/use-toast';
import { AuthContext } from '../context/AuthContext';
import api from '../lib/api';

function ClubSingle() {
    const navigate = useNavigate();
    const { clubId } = useParams();
    const { auth } = useContext(AuthContext);

    const [club, setClub] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isLinkLoading, setLinkIsLoading] = useState(true);

    const [inviteMemberDialogOpen, setInviteMemberDialogOpen] = useState(false);
    const [link, setLink] = useState('');

    useEffect(() => {
        if (!inviteMemberDialogOpen) return;
        setLinkIsLoading(true);

        api.post(`https://skhrf-api.cmdigital.se/v1/clubs/invite`, { clubId: parseInt(clubId) })
            .then(response => {
                setLink(window.location.origin + '/signup?secret=' + response.data.secret); // Set link to the response from the API
                setLinkIsLoading(false); // Data fetched, set loading to false
            })
            .catch(error => {
                console.error('Error fetching clubs:', error);
                setLink('Internt fel. Försök igen senare.');
                setLinkIsLoading(false); // Error occurred, set loading to false
            });
    }, [inviteMemberDialogOpen, clubId]);

    useEffect(() => {
        axios.get(`https://skhrf-api.cmdigital.se/v1/clubs?clubId=${clubId}`)
            .then(response => {

                // Redirect to /clubs if 404 error
                if (response.data.length < 1) {
                    toast({
                        variant: 'destructive',
                        title: 'Något gick fel.',
                        description: 'Föreningen du efterfrågade finns inte.',
                    });
                    navigate('/clubs');
                }

                setClub(response.data[0]);
                setIsLoading(false); // Data fetched, set loading to false
            })
            .catch(error => {
                console.error('Error fetching members:', error);
                setIsLoading(false); // Error occurred, set loading to false

                // Redirect to /clubs if 404 error
                if (error.response?.status === 404) {
                    toast({
                        variant: 'destructive',
                        title: 'Något gick fel.',
                        description: 'Föreningen du efterfrågade finns inte.',
                    });
                    navigate('/clubs');
                }
            });
    }, [clubId, navigate]);

    return (
        <div className='flex w-full items-center justify-center'>
            <div className='flex w-5/6 sm:w-3/4 flex-col py-6 gap-3'>
                <div className='grid grid-cols-1 xl:grid-cols-2 items-center'>
                    <h1 className='font-medium text-2xl'>
                        {isLoading ? (<Skeleton className='h-10 w-52' />) : (
                            club.abbreviation + " - " + club.name
                        )}
                    </h1>
                    {(auth.user?.superadmin || (auth.user?.roleInClub === 'admin' && auth.user?.memberOfClub === parseInt(clubId))) && (
                        <div className='grid grid-cols-1 sm:grid-cols-2 gap-3 pt-3'>
                            <Dialog open={inviteMemberDialogOpen} onOpenChange={setInviteMemberDialogOpen}>
                                <DialogTrigger asChild>
                                    <Button >
                                        <PlusCircledIcon className='mr-3' />
                                        Lägg till medlem
                                    </Button>
                                </DialogTrigger>
                                <InviteMemberDialog link={link} clubName={club.name} isLoading={isLinkLoading} />
                            </Dialog>
                            <Button variant='secondary' onClick={() => navigate(`/clubs/${club.id}/clubinformation`)}>
                                <Pencil1Icon className='mr-3' />
                                Ändra föreningsinformation
                            </Button>
                        </div>
                    )}
                </div>
                <Accordion type="single" collapsible defaultValue='item-1'>
                    <AccordionItem value="item-1">
                        <AccordionTrigger>Allmän information</AccordionTrigger>
                        <AccordionContent className='flex flex-col gap-3'>
                            <div className='rounded-md bg-gray-100 p-3'>
                                <h2 className='font-medium text-lg'>Föreningsinformation</h2>
                                {isLoading ? (<Skeleton className='w-64 h-4' />) : (
                                    <ExternalLinkWrapper>
                                        <div dangerouslySetInnerHTML={{ __html: club.description }} />
                                    </ExternalLinkWrapper>
                                )}
                            </div>
                            <div className='rounded-md bg-gray-100 p-3'>
                                <h2 className='font-medium text-lg'>Betalningsinformation</h2>
                                {isLoading ? (<Skeleton className='w-64 h-4' />) : (
                                    <ExternalLinkWrapper>
                                        <div dangerouslySetInnerHTML={{ __html: club.payment_information }} />
                                    </ExternalLinkWrapper>
                                )}
                            </div>
                        </AccordionContent>
                    </AccordionItem>
                    <AccordionItem value='item-2'>
                        <AccordionTrigger>Tävlingar</AccordionTrigger>
                        <AccordionContent>
                            <div className='rounded-md bg-gray-100 p-3'>
                                <ClubCompetitionsDatatable clubId={clubId} />
                            </div>
                        </AccordionContent>
                    </AccordionItem>
                    {(auth.user?.superadmin || (auth.user?.roleInClub === 'admin' && auth.user?.memberOfClub === parseInt(clubId))) && (
                        <AccordionItem value='item-3'>
                            <AccordionTrigger>Medlemmar</AccordionTrigger>
                            <AccordionContent>
                                <div className='rounded-md bg-gray-100 p-3'>
                                    <MemberDataTable
                                        clubId={clubId}
                                    />
                                </div>
                            </AccordionContent>
                        </AccordionItem>
                    )}
                </Accordion>
            </div>
        </div>
    );
}

export default ClubSingle;